<template>

		<li v-editable="blok" class="flex flex-row gap-4 md:gap-10 pt-6 text-block md:pr-8 w-full">
			<div class="bg-primary-500 rounded-lg flex h-12 md:h-16 aspect-square justify-center items-center item-nr">
				<p class="text-3xl">{{ blok.number }}</p>
			</div>
			<div class="pt-4">
				<h4 v-if="blok.title" class="text-2xl font-bold pb-2">{{ blok.title }}</h4>
				<div class="text-sm text-block" v-html="body"></div>
			</div>
			
		</li>
</template>
 
<script setup>
import { renderRichText2 } from '~/utils/richtext'
const props = defineProps({ blok: Object })
const body = computed(() => renderRichText2(props.blok.body))
</script>
<style scoped>
.text-block a {
	color: #BF8DFF;
}
.text-block a:hover {
	color: #d7b8ff;
}
.text-block {
	margin-left: 0 !important;
}
</style>